import { Component, OnInit, OnDestroy } from '@angular/core';
import { BookingStepService } from '../../services/booking-step.service';
import { LoggerService } from '../../../../services/logger/logger.service';
import { LoadingSpinnerService } from '../../../../services/loading-spinner.service';
import { BookingOrderService } from '../../services/booking-order.service';
import { AreaItemPack } from '../../models/area-item-pack';
import { BookingStepEnum } from '../../models/booking-step.enum';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-booking-router',
  templateUrl: './booking-router.component.html',
  styleUrls: ['./booking-router.component.css']
})

export class BookingRouterComponent implements OnInit, OnDestroy {
  private _routerSubscription: any;

  constructor(
    private bookingStepService: BookingStepService,
    private logger: LoggerService,
    private loadingSpinnerService: LoadingSpinnerService,
    private bookingOrderService: BookingOrderService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
  ) { }

  ngOnInit(): void {
    this.loadingSpinnerService.show();
    this.bookingStepService.initialize().subscribe(
      done => {
        this._routerSubscription = this.activatedRoute.paramMap.subscribe(params => {
          const eventPackName = params.get('eventPackName');
          const productPackName = params.get('productPackName');

          if (eventPackName) {
            this.navigateByEventPackName(eventPackName);
          }

          if (productPackName) {
            this.navigateByProductPackName(productPackName);
          }

        });
        this.loadingSpinnerService.hide();
        this.logger.info('EventComponent: bookingStateService initialized.');
      },
      error => {
        this.loadingSpinnerService.hide();
        this.logger.error(`EventComponent: bookingStateService reinitialized error: ${error.message}.`);
      }
    );
  }
  ngOnDestroy(): void {
    if (this._routerSubscription) {
      this._routerSubscription.unsubscribe();
    }
  }

  get eventAreaItemPacks(): AreaItemPack[] {
    return this.bookingOrderService.mainPageAreaItemPacks
      ? this.bookingOrderService.mainPageAreaItemPacks.filter(x => x.areaItems && x.areaItems.length !== 0)
      : [];
  }

  get singleAreaItemPacks(): AreaItemPack[] {
    return this.bookingOrderService.areaItemPacks.filter(x => !x.showOnHomePage && x.areaItems && x.areaItems.length !== 0);
  }

  navigateByEventPackName(eventPackName: string): void {
    const eventAreaItemPacks = this.getAreaItemPackByEventRouterName(eventPackName, this.eventAreaItemPacks);

    if (!eventAreaItemPacks || eventAreaItemPacks.length === 0) {
      this.router.navigate(['booking/event']);
      return;
    }

    const eventAreaItemPack = eventAreaItemPacks[0];

    this.bookingStepService.update(
      BookingStepEnum.SelectBookingEventsPacks,
      eventAreaItemPack,
      eventAreaItemPack.areaItems[0]
    );
  }

  navigateByProductPackName(productPackName: string): void {
    const productAreaItemPacks = this.getAreaItemPackByEventRouterName(productPackName, this.singleAreaItemPacks);

    if (!productAreaItemPacks || productAreaItemPacks.length === 0) {
      this.router.navigate(['booking']);
      return;
    }

    const productAreaItemPack = productAreaItemPacks[0];

    this.bookingStepService.update(
      BookingStepEnum.SelectBookingPacks,
      productAreaItemPack,
      productAreaItemPack.areaItems[0]
    );
  }

  getAreaItemPackByEventRouterName(eventRouterName: string, areaItemPacks: AreaItemPack[]): AreaItemPack[] {
    let productAreaItemPack = null;
    if (eventRouterName && eventRouterName !== '' && areaItemPacks && areaItemPacks.length > 0) {
      if (areaItemPacks) {
        productAreaItemPack = areaItemPacks.filter(x => x.eventRouterName === eventRouterName);
      }
    }
    return productAreaItemPack;
  }
}
